export const APP_ROUTES = {
  HOME: '/',
  DASHBOARD: '/app/dashboard',
  MANAGE_VENUES: '/app/venues',
  INBOX: '/app/inbox/:id',
  REVIEWS: '/app/reviews',
  TRANSACTIONS: '/app/transactions',
  VENDOR_EVENT_GUIDE: '/app/event/:id/guide',
  VENDOR_EVENT_REGISTRATION: '/app/event/:id/registration',
  VENDOR_DASHBOARD: '/app/vendor/dashboard',
  UPDATE_EVENT: '/app/event/:id/update',
  VENDOR_PROFILE: '/app/profile/',
  EVENT_DETAILS: '/app/event/:eventId',
  EVENT_MANAGEMENT: '/app/event/:eventId/mgmt',
  CATEGORIES: '/app/categories',
  VENDOR_PUBLIC_PROFILE: '/app/vendor/:vendorId/public-profile',
  EVENTS_ADMIN_SEARCH: '/app/dashboard/event-search/',
  PENDING_VENUES: '/app/venue/pending/',
  REGISTERED_VENUES: '/app/venue/registered/',
  SYSTEM_PARAMETERS: '/app/system-parameters/',
  MANAGE_REVIEWS: '/app/adm/reviews',
  VENDORS_ADMIN_SEARCH: '/app/dashboard/vendor-search/',
  VENUE_TRANSACTIONS: '/app/dashboard/venue-transactions/',
  VENUE_TRANSACTIONS_EVENT: '/app/dashboard/venue-transactions/:venueId',
  VENUE_TRANSACTIONS_EVENT_MONEY_MOVEMENT:
    '/app/dashboard/venue-transactions/:venueId/event/:eventId',
  STRIPE_REDIRECT: '/app/stripe',
  ABOUT_US: '/app/about-us',
  VENUE_APPLICATIONS_ADMIN_SEARCH: '/app/venue-applications',
  VENUE_PUBLIC_PROFILE: '/app/venue/:venueId/public-profile',
  RETAIL_OPPORTUNITY_DETAILS: '/app/retail-opportunity/:profileId',
  RETAIL_BOOKING: '/app/retail-booking/:id',
  RETAIL_PAYMENTS: '/app/retail-payments',
  EVENT_PAYMENTS: '/app/event-payments',
};
